<template>
  <div class="card">
    <div class="card__content">
      <h1 class="card__heading">
        Get <span>insights</span> that help your business grow.
      </h1>
      <p class="card__body">{{ body }}</p>

      <!-- stats -->
      <div class="card__stat-group">
        <div class="card__stat">
          <div class="card__metric">10k+</div>
          <div class="card__metrtic-title">companies</div>
        </div>
        <div class="card__stat">
          <div class="card__metric">314</div>
          <div class="card__metrtic-title">templates</div>
        </div>
        <div class="card__stat">
          <div class="card__metric">12m+</div>
          <div class="card__metrtic-title">queries</div>
        </div>
      </div>
    </div>

    <!-- image -->
    <div class="card__image-container">
      <img
        class="card__image"
        alt="office space"
        :src="this.size > 700 ? desktop : mobile"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props: {
    heading: String,
    body: String,
  },
  data() {
    return {
      desktop: require("@/assets/image-header-desktop.jpg"),
      mobile: require("@/assets/image-header-mobile.jpg"),
      size: window.innerWidth,
    };
  },
};
</script>

<style lang="scss">
.card {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  background: #1b1937;
  box-shadow: 0px 20px 20px -10px rgba(23, 25, 41, 0.203087);
  border-radius: 8px;

  width: 327px;
  height: 780px;

  @media (min-width: 768px) {
    flex-direction: row;
    height: 446px;
    width: 1110px;
  }

  &__image-container {
    order: 1;

    width: 327px;
    height: 240px;
    margin-bottom: 16px;
    background: #ab5cdb;
    border-radius: 8px 8px 0 0;

    @media (min-width: 768px) {
      border-radius: 0 8px 8px 0;
      oreder: 2;
      height: 446px;
      width: 540px;
    }
  }

  &__image {
    height: inherit;
    width: inherit;
    opacity: 0.7;
    border-radius: 8px 8px 0 0;
    filter: contrast(200%) hue-rotate(90deg) grayscale(80%);

    @media (min-width: 768px) {
      border-radius: 0 8px 8px 0;
    }
  }

  &__content {
    order: 2;
    height: 540px;
    width: 327px;
    padding: 30px 31.5px 32px;

    @media (min-width: 768px) {
      order: 1;
      height: 446px;
      width: 570px;
      padding: 71px 72px 59px 95px;
    }
  }

  &__heading {
    font-style: normal;
    font-weight: bold;
    font-size: 28px;
    line-height: 32px;
    text-align: center;
    color: #ffffff;

    width: 264px;
    height: 96px;
    margin-bottom: 16px;

    @media (min-width: 768px) {
      font-size: 36px;
      line-height: 44px;
      text-align: left;

      width: 403px;
      height: 88px;
    }
  }

  span {
    color: #ab5cdb;
  }

  &__body {
    width: 264px;
    height: 100px;
    margin-bottom: 40px;

    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 25px;
    text-align: center;
    opacity: 0.6;
    color: #ffffff;

    @media (min-width: 768px) {
      width: 374px;
      height: 75px;

      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 25px;
      text-align: left;
    }
  }

  &__stat-group {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 216px;
    width: 264px;

    @media (min-width: 768px) {
      align-items: left;
      flex-direction: row;
      text-align: left;
      height: 56px;
      width: 351.5px;
    }
  }

  &__stat {
    text-align: left;
    height: 56px;
  }

  &__metric {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 29px;

    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 29px;

    color: #ffffff;
  }

  &__metrtic-title {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 29px;

    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 25px;
    color: #ffffff;
    opacity: 0.6;

    letter-spacing: 1px;
    text-transform: uppercase;
  }
}
</style>
